<template>
    <div>
        <app-form-textarea-input
            title="Escriba la nota"
            label="Escriba la nota"
            v-model="note.note"
            error-message="Debe escribir la nota"
            :has-error="$v.note.note.$error"
            :required="required"
        />
    </div>
</template>
<script>
import tasksRepository from "../../../../../repositories/tasks.repository.js";
import { required } from "vuelidate/lib/validators";
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        task: {
            type: Object
        },
        onSave: {
            type: Function
        },
        hasError: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: ""
        },
        required: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            note: {
                taskId: "",
                userId: "",
                note: ""
            }
        };
    },

    validations: {
        note: {
            note: { required }
        }
    },

    methods: {
        saveNote() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            }

            this.note.userId = this.user.id;
            this.note.taskId = this.task.id;

            const tr = Object.assign({}, tasksRepository);
            tr.saveNoteTask(this.note)
                .then(data => {
                    if (data.status) {
                        this.cleanFields();
                        typeof this.onSave === "function" && this.onSave();
                        toastr.success(data.msg);
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al guardar nota");
                });
        },
        cleanFields() {
            Object.keys(this.note).map(key => (this.note[key] = ""));
            this.$nextTick(() => {
                this.$v.$reset();
            });
        }
    },

    created() {
        this.$bus.$on(`${this.id}.save`, this.saveNote);
        this.$bus.$on(`${this.id}.clean`, this.cleanFields);
    },
    beforeDestroy() {
        this.$bus.$off(`${this.id}.save`);
    }
};
</script>
